export const TRADE_ORDER_PAGE_UUID = 'd6ec28d7-adb2-482e-92d9-135a4ca07cf7'
